import GalleryPicker from './GalleryPicker';

export default GalleryPicker;
